import React, { Fragment, useState } from 'react';
import { Flex, Box, Heading, Text, Card, Button } from 'rebass';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { Link, withRouter } from 'react-router-dom';
import { compose, withApollo, Query, Mutation } from 'react-apollo';
import { withToastManager } from 'react-toast-notifications';

import SpinLoader from '../components/SpinLoader';
import withAnalytics from '../lib/withAnalytics';
import { GET_PALOMA_RX, GET_RX_TOKEN, LatestFromPhysician } from './myRx';
import PillsBottle from '../static/PillsBottle.png';
import Communicator from '../pages/consultations/Communicator';
import PerpetualCommunicator from '../pages/perpetualCommunicator/Communicator';
import fleche from '../static/fleche.png';
import Estriol from '../static/Estriol.png';

import { isMobile, isTablet } from 'react-device-detect';
import { isPreviewMode } from '../utils/environments';
import { useEffect } from 'react';

const REDIRECT_URL = '/my-rx';

const Icon2 = styled(Flex)`
  @media screen and (max-width: 480px) {
    display: none;
  }
`;
const DetailNavigation = styled.div`
  flex: 1;
  margin-bottom: 36px;
  margin-left: -16px;
  margin-top: -16px;
  @media screen and (min-width: 68.8125em) {
    display: none;
    margin-bottom: 0px;
    margin-left: 0;
    margin-top: 0;
  }
`;

const ImgTopMobile = styled.img`
  display: none;
  object-fit: cover;
  border-radius: 12px;
  max-height: 50%;
  @media screen and (max-width: 999px) {
    object-fit: contain;
  }
  @media screen and (max-width: 52em) {
    display: initial;
  }
`;

const CommunicatorFlex = styled(Flex)`
  width: 100%;
  flex-direction: column;
  @media screen and (min-width: 52em) {
    width: calc(100% - 80px);
  }
`;

const CommunicatorChoiceDesktopOnly = styled.div`
  @media screen and (max-width: 52em) {
    display: none;
  }
  max-height: calc(100% - 80px);
`;

const CommunicatorChoiceMobileOnly = styled.div`
  @media screen and (min-width: 52em) {
    display: none;
  }
`;

const WrapperFlex = styled(Flex)`
  padding: 16px;
  flex-direction: column;
  padding-bottom: 128px;
  position: relative;
  background-color: #fdfbfc;
`;

const BackButton = styled.div`
  background: rgba(180, 205, 244, 0.5);
  /* width: 100%; */
  color: #333;
  padding: 6px 12px;

  /* @media screen and (min-width: 68.8125em) {
    display: none;
  } */
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;
const TableHead = styled.thead`
  border-bottom: 1px solid #e5e5e5;
`;

const HeaderCell = styled.th`
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #6a7282;
  text-transform: uppercase;

  &:first-child {
    text-align: left;
  }

  &:not(:first-child) {
    text-align: right;
  }
`;

const TableRow = styled.tr`
  &:last-child {
    border-top: 1px solid #f0f0f0;
    border-bottom: none;
  }
`;

const TableCell = styled.td`
  padding: 0px 16px;
  font-size: 14px;
  color: rgb(52, 79, 121);

  &:first-child {
    text-align: left;
    font-weight: 500;
  }

  &:not(:first-child) {
    text-align: right;
  }
  &:last-child {
    padding: 8px 16px;
  }
`;

const Img = styled.img`
  display: initial;
  @media screen and (max-width: 52em) {
    display: none;
  }
`;

const FlexNotMobile = styled(Flex)`
  display: flex;
  @media screen and (max-width: 52em) {
    display: none;
  }
`;

const FlexMobile = styled(Flex)`
  display: none;
  @media screen and (max-width: 52em) {
    display: flex;
    position: relative;
  }
`;

const PrescriptionDetails = ({ prescription, manageRx, isLoadingManage }) => {
  if (!prescription.medication) {
    return null;
  }

  return (
    <Flex style={{ gap: 30 }}>
      <FlexNotMobile flexDirection={'column'} alignItems={'center'} style={{ gap: 20 }}>
        <Flex flex={1}>
          <Img src={(prescription.medication.productMetadata || {}).imageUrl || PillsBottle} width={'200px'} style={{ objectFit: 'scale-down' }} />
        </Flex>
        <Button variant={'primary'} p={'6px 24px !important'} style={{ backgroundColor: '#4E658A', width: 'fit-content', fontWeight: 500 }} onClick={manageRx} disabled={!!isLoadingManage}>
          Manage Rx
        </Button>
      </FlexNotMobile>
      <Flex flexDirection={'column'} flex={1}>
        <Text fontWeight={500} fontSize={18}>
          SIG
        </Text>

        <Text>{prescription.medication.frequency}</Text>
        <Card style={{ padding: 20, borderRadius: '0.5rem', marginTop: '16px' }} flex={1}>
          <Flex flexDirection={'column'} style={{ gap: 12 }}>
            <Flex>
              <Flex flexDirection={'column'} flex={1}>
                <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 14 }}>Quantity</Text>
                <Text style={{ fontSize: 14, fontWeight: 700 }}>{prescription.medication.quantity}</Text>
              </Flex>
              <Flex flexDirection={'column'} flex={1}>
                <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 14 }}>Strength</Text>
                <Text style={{ fontSize: 14, fontWeight: 700 }}>
                  {prescription.medication.strength} {prescription.medication.strengthUnit || ''}
                </Text>
              </Flex>
            </Flex>
            <Flex>
              <Flex flexDirection={'column'} flex={1}>
                <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 14 }}>Refills Allowed</Text>
                <Text style={{ fontSize: 14, fontWeight: 700 }}>{prescription.refillsAllowed}</Text>
              </Flex>
              <Flex flexDirection={'column'} flex={1}>
                <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 14 }}>Refills Remaining</Text>
                <Text style={{ fontSize: 14, fontWeight: 700 }}>{prescription.refillsRemaining}</Text>
              </Flex>
            </Flex>
            <Flex>
              <Flex flexDirection={'column'} flex={1}>
                <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 14 }}>Prescriber</Text>
                <Text style={{ fontSize: 14, fontWeight: 700 }}>{prescription.prescriber}</Text>
              </Flex>
            </Flex>
            <Flex>
              <Flex flexDirection={'column'} flex={1}>
                <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 14 }}>Written Date</Text>
                <Text style={{ fontSize: 14, fontWeight: 700 }}>{prescription.writtenDate ? moment(prescription.writtenDate).format('MMMM DD, YYYY') : ''}</Text>
              </Flex>
              <Flex flexDirection={'column'} flex={1}>
                <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 14 }}>Rx Expiration</Text>
                <Text style={{ fontSize: 14, fontWeight: 700 }}>{prescription.expirationDate ? moment(prescription.expirationDate).format('MMMM DD, YYYY') : ''}</Text>
              </Flex>
            </Flex>
          </Flex>
        </Card>
      </Flex>
    </Flex>
  );
};

const Fill = ({ fill, isLast }) => {
  return (
    <Flex flexDirection={'column'} style={{ padding: '0px 20px 16px', gap: 12 }}>
      <Flex justifyContent={'space-between'}>
        <Flex style={{ gap: 8 }}>
          <Text style={{ fontSize: 16, fontWeight: 700 }}>Fill #{fill.fillNumber}</Text>
          {!!isLast && (
            <Box
              style={{
                background: '#dbeafe',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '2px 8px',
                display: 'flex',
                borderRadius: '5px',
                height: 'fit-content',
              }}
            >
              <Text style={{ fontSize: 12, margin: 0, padding: 0 }}>latest</Text>
            </Box>
          )}
        </Flex>
      </Flex>

      <Flex>
        <Flex flexDirection={'column'} flex={1}>
          <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 12 }}>Quantity</Text>
          <Text style={{ fontSize: 14 }}>{fill.quantity}</Text>
        </Flex>
        <Flex flexDirection={'column'} flex={1}>
          <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 12 }}>Days Supply</Text>
          <Text style={{ fontSize: 14 }}>{fill.daysSupply}</Text>
        </Flex>
        <Flex flexDirection={'column'} flex={1}>
          <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 12 }}>Filled On</Text>
          <Text style={{ fontSize: 14 }}>{fill.fillDate || ''}</Text>
        </Flex>
        <Flex flexDirection={'column'} flex={1}>
          <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 12 }}>Next Fill Eligible</Text>
          <Text style={{ fontSize: 14 }}>{fill.dates ? fill.dates.eligibleRefillDate : ''}</Text>
        </Flex>
        <Flex flexDirection={'column'} flex={1}>
          <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 12 }}>Payment</Text>
          <Text style={{ fontSize: 14 }}>{fill.payment && fill.payment.amount !== null && fill.payment.amount !== undefined ? `$${fill.payment.amount / 100} (${fill.payment.status})` : ''}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

const ShipmentTracking = ({ tracking, order }) => {
  return (
    <Flex flexDirection={'column'} style={{ padding: '0px 20px 16px', gap: 12 }}>
      <Flex>
        <Flex flexDirection={'column'} flex={1}>
          <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 12 }}>Carrier</Text>
          <Text style={{ fontSize: 14 }}>
            {tracking.carrier} {tracking.method ? `(${tracking.method})` : ''}
          </Text>
        </Flex>
        <Flex flexDirection={'column'} flex={1}>
          <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 12 }}>Tracking #</Text>
          {tracking.trackingUrl ? (
            <a
              href={tracking.trackingUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: 14, color: '#3278F9', fontWeight: 500 }}
              onClick={(e) => {
                window.open(tracking.trackingUrl, '_blank');
                // console.log('defaultPrevented:', e.defaultPrevented);
              }}
            >
              {tracking.trackingNumber}
            </a>
          ) : (
            <Text style={{ fontSize: 14 }}>{tracking.trackingNumber}</Text>
          )}
        </Flex>
        <Flex flexDirection={'column'} flex={1}>
          <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 12 }}>Status</Text>
          <Text style={{ fontSize: 14, color: (tracking.latestStatus || '').toLowerCase() === 'delivered' ? '#338D6A' : '' }}>{tracking.latestStatus || 'unknown'}</Text>
        </Flex>
        {tracking.deliveredAt ? (
          <Flex flexDirection={'column'} flex={1}>
            <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 12 }}>Delivered on</Text>
            <Text style={{ fontSize: 14 }}>{moment(tracking.deliveredAt).format('YYYY/MM/DD')}</Text>
          </Flex>
        ) : (
          <>
            {tracking.estimatedDelivery ? (
              <Flex flexDirection={'column'} flex={1}>
                <Text style={{ color: '#6a7282', fontWeight: 500, fontSize: 12 }}>Est. Delivery</Text>
                <Text style={{ fontSize: 14 }}>{moment(tracking.estimatedDelivery).format('YYYY/MM/DD')}</Text>
              </Flex>
            ) : null}
          </>
        )}
      </Flex>
    </Flex>
  );
};

const FillsHistory = ({ prescription }) => {
  const LastFill = prescription.fills && prescription.fills.length > 0 ? prescription.fills[prescription.fills.length - 1] : null;
  return (
    <>
      <Card style={{ borderRadius: '0.5rem', flexDirection: 'column', display: 'flex' }}>
        <Flex style={{ padding: '16px 20px', borderBottom: '1px solid #e5e7eb', marginBottom: 16 }} justifyContent={'space-between'} alignItems={'center'}>
          <Text fontWeight={500} fontSize={18}>
            Fill History ({(prescription.fills || []).length})
          </Text>
        </Flex>
        {!LastFill && (
          <Flex justifyContent={'center'} alignItems={'center'} p={'0px 0 20px'}>
            <Text style={{ textAlign: 'center', opacity: 0.7 }}>No Fill Yet...</Text>
          </Flex>
        )}
        {(prescription.fills || []).map((x, i) => {
          return <Fill fill={x} isLast={(prescription.fills || []).length - 1 === i} key={x.id} />;
        })}
      </Card>
      {!!LastFill &&
        LastFill.shipping && (
          <Card style={{ borderRadius: '0.5rem', flexDirection: 'column', display: 'flex', background: '#F1F5FD' }}>
            <Flex style={{ padding: '16px 20px', borderBottom: '1px solid #e5e7eb', marginBottom: 16 }} justifyContent={'space-between'} alignItems={'center'}>
              <Text fontWeight={500} fontSize={18}>
                Shipment Tracking
              </Text>
            </Flex>
            <ShipmentTracking tracking={LastFill.shipping} />
          </Card>
        )}
    </>
  );
};

const ProductInformation = ({ prescription }) => {
  if (!prescription || !prescription.medication || !prescription.medication.productMetadata || !prescription.medication.productMetadata.productInformation) return null;
  return (
    <>
      <Card style={{ borderRadius: '0.5rem', flexDirection: 'column', display: 'flex' }}>
        <Flex style={{ padding: '16px 20px', borderBottom: '1px solid #e5e7eb', marginBottom: 16 }} justifyContent={'space-between'} alignItems={'center'}>
          <Text fontWeight={500} fontSize={18}>
            Product Information
          </Text>
        </Flex>
        <Flex justifyContent={'center'} p={'20px 20px'}>
          <Text dangerouslySetInnerHTML={{ __html: prescription.medication.productMetadata.productInformation }} />
        </Flex>
      </Card>
    </>
  );
};

const CheckoutSummary = ({ prescription }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  if (!prescription || !prescription.orders || prescription.orders.length < 1) return null;

  const order = prescription.orders[0];
  if (!order.pricing) {
    return null;
  }

  return (
    <Card style={{ borderRadius: '0.5rem', flexDirection: 'column', display: 'flex' }}>
      <Flex style={{ padding: '16px 20px', borderBottom: '1px solid #e5e7eb', marginBottom: 16 }} justifyContent={'space-between'} alignItems={'center'}>
        <Text fontWeight={500} fontSize={18}>
          Checkout Summary
        </Text>
      </Flex>
      {!!isExpanded && (
        <Flex flexDirection={'column'} style={{ padding: '0px 20px 16px', gap: 12 }}>
          <Table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
            }}
          >
            <TableHead>
              <tr>
                <HeaderCell>ITEMS</HeaderCell>
                <HeaderCell>AMOUNT</HeaderCell>
              </tr>
            </TableHead>

            <tbody>
              {!isNaN(order.pricing.medicationCost) && (
                <TableRow>
                  <TableCell>Prescription medication</TableCell>
                  <TableCell>${(order.pricing.medicationCost / 100).toFixed(2)}</TableCell>
                </TableRow>
              )}
              {!isNaN(order.pricing.dispensingFee) && (
                <TableRow>
                  <TableCell>Dispensing fee</TableCell>
                  <TableCell>${(order.pricing.dispensingFee / 100).toFixed(2)}</TableCell>
                </TableRow>
              )}
              {!isNaN(order.pricing.shippingFee) && (
                <TableRow>
                  <TableCell>Shipping fee</TableCell>
                  <TableCell>${(order.pricing.shippingFee / 100).toFixed(2)}</TableCell>
                </TableRow>
              )}
              {!isNaN(order.pricing.serviceFee) && (
                <TableRow>
                  <TableCell>Paloma service fee</TableCell>
                  <TableCell>${(order.pricing.serviceFee / 100).toFixed(2)}</TableCell>
                </TableRow>
              )}
              {!isNaN(order.pricing.total) && (
                <TableRow>
                  <TableCell style={{ fontWeight: 700 }}>Total</TableCell>
                  <TableCell style={{ fontWeight: 700 }}>${(order.pricing.total / 100).toFixed(2)}</TableCell>
                </TableRow>
              )}
            </tbody>
          </Table>
        </Flex>
      )}
    </Card>
  );
};

const RxCommunicator = ({ prescription }) => {
  if (!prescription || !prescription.isLdn) return null;
  // <PerpetualCommunicator appointmentId={appointment.id} appointment={appointment} isAsync={false} />
  // return null
  return (
    <>
      {isMobile && !isTablet ? (
        <Card p={[3, 3, 4]} style={{ marginBottom: '64px' }}>
          <Flex>
            <Icon2 mr={[0, '12px', '12px']}>
              <img src={fleche} height={70} width={70} alt="" />
            </Icon2>

            <CommunicatorFlex id="t1">
              <Heading mb={4}>A question for your clinician?</Heading>
              <CommunicatorChoiceMobileOnly id="t2">
                <div
                  id="t2"
                  style={{
                    border: '1px solid rgb(52, 79, 121)',
                    padding: '6px',
                    borderRadius: '4px',
                    boxShadow: '6px 6px 5px 0px rgba(52, 79, 121, 0.35)',
                    marginBottom: '12px',
                  }}
                  onClick={() => {
                    this.props.history.push({
                      pathname: `/consultations-communicator/-1`,
                      state: { isAsync: false, blockSend: false },
                    });
                  }}
                >
                  <Flex flexDirection="row" id="t4">
                    <Flex flexDirection="column" id="t5">
                      <Text fontWeight="500">Chat with your provider</Text>
                      <Text fontWeight="300" fontSize="14px">
                        {`usually reply within 3 to 5 business days`}
                      </Text>
                    </Flex>
                  </Flex>
                </div>
              </CommunicatorChoiceMobileOnly>
            </CommunicatorFlex>
          </Flex>
        </Card>
      ) : (
        <Card p={[3, 3, 4]} style={{ marginBottom: '64px' }}>
          <Flex>
            <Icon2 mr={[0, 4, 4]}>
              <img src={fleche} height={50} width={50} alt="" />
            </Icon2>

            <CommunicatorFlex id="t1" style={{ maxHeight: '600px', position: 'relative' }}>
              <Heading mb={4}>A question for your clinician?</Heading>
              <CommunicatorChoiceDesktopOnly>
                {!prescription.isLdn ? (
                  <Communicator appointmentId={'-1'} appointment={null} prescription={null} summary={null} isAsync={true} blockSend={false} />
                ) : (
                  <PerpetualCommunicator appointmentId={'-1'} appointment={null} isAsync={false} />
                )}
              </CommunicatorChoiceDesktopOnly>
            </CommunicatorFlex>
          </Flex>
        </Card>
      )}
    </>
  );
};

const StatusBadge = ({ prescription }) => {
  if (!prescription || !prescription.status) return null;

  switch (prescription.status.toLowerCase()) {
    case 'active':
      return (
        <Card p={'3px 12px'} style={{ background: '#CFEEDE', maxWidth: 'fit-content', borderRadius: 20 }}>
          <Text fontSize={14} fontWeight={300} color={'#034630'}>
            Active
          </Text>
        </Card>
      );
    case 'cancelled':
      return (
        <Card p={'3px 12px'} style={{ background: '#e6e6e6', maxWidth: 'fit-content', borderRadius: 20 }}>
          <Text fontSize={14} fontWeight={300} color={'#4a4a4a'}>
            {prescription.status}
          </Text>
        </Card>
      );
    default:
      return (
        <Card p={'3px 12px'} style={{ background: '#f3e8d7', maxWidth: 'fit-content', borderRadius: 20 }}>
          <Text fontSize={14} fontWeight={300} color={'#553b16'}>
            {prescription.status.replace('_', ' ')}
          </Text>
        </Card>
      );
  }
};

const ProductSpecifications = ({ productMetadata }) => {
  if (!productMetadata || (!productMetadata.importantSafetyInformation && !productMetadata.warnings)) return null;
  const { importantSafetyInformation, warnings } = productMetadata;

  return (
    <>
      {importantSafetyInformation && (
        <Flex flexDirection={'column'} style={{ gap: '10px' }}>
          <Heading style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none">
              <path
                d="M8 1L2 3V9C2 12.3141 4.68594 15 8 15C11.3141 15 14 12.3141 14 9V3L8 1ZM12.875 9C12.875 11.6922 10.6922 13.875 8 13.875C5.30781 13.875 3.125 11.6922 3.125 9V3.84375L8 2.125L12.875 3.84375V9Z"
                fill="#8d4b3f"
              />
              <path
                d="M5.91271 7.42344C5.86057 7.37106 5.7986 7.32951 5.73036 7.30115C5.66212 7.27279 5.58895 7.25819 5.51505 7.25819C5.44115 7.25819 5.36798 7.27279 5.29974 7.30115C5.2315 7.32951 5.16953 7.37106 5.11739 7.42344C5.06502 7.47557 5.02346 7.53754 4.9951 7.60578C4.96675 7.67402 4.95215 7.74719 4.95215 7.82109C4.95215 7.89499 4.96675 7.96816 4.9951 8.03641C5.02346 8.10465 5.06502 8.16662 5.11739 8.21875L7.13927 10.2406L7.17208 10.2734C7.2214 10.3228 7.27997 10.362 7.34445 10.3888C7.40893 10.4155 7.47806 10.4293 7.54786 10.4293C7.61767 10.4293 7.68679 10.4155 7.75127 10.3888C7.81575 10.362 7.87433 10.3228 7.92364 10.2734L11.4158 6.78125C11.4652 6.73194 11.5044 6.67336 11.5312 6.60888C11.5579 6.5444 11.5717 6.47528 11.5717 6.40547C11.5717 6.33566 11.5579 6.26654 11.5312 6.20206C11.5044 6.13758 11.4652 6.079 11.4158 6.02969L11.3721 5.98594C11.3228 5.93653 11.2642 5.89733 11.1997 5.87059C11.1352 5.84384 11.0661 5.83008 10.9963 5.83008C10.9265 5.83008 10.8574 5.84384 10.7929 5.87059C10.7284 5.89733 10.6698 5.93653 10.6205 5.98594L7.54708 9.05781L5.91271 7.42344Z"
                fill="#8d4b3f"
              />
            </svg>
            Important Safety Information
          </Heading>

          <Flex style={{ marginLeft: 12, paddingLeft: 20, borderLeft: '2px solid #8d4b3f' }}>
            <Text dangerouslySetInnerHTML={{ __html: importantSafetyInformation }} />
          </Flex>
        </Flex>
      )}
      {warnings && (
        <Flex flexDirection={'column'} style={{ gap: '10px' }}>
          <Heading style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none">
              <path
                d="M1.8168 14C1.69458 14 1.58347 13.9696 1.48347 13.9087C1.38347 13.8478 1.30569 13.7671 1.25013 13.6667C1.19458 13.5662 1.16413 13.4578 1.1588 13.3413C1.15347 13.2249 1.18391 13.1111 1.25013 13L7.4168 2.33333C7.48347 2.22222 7.56969 2.13889 7.67547 2.08333C7.78124 2.02778 7.88947 2 8.00013 2C8.1108 2 8.21924 2.02778 8.32547 2.08333C8.43169 2.13889 8.51769 2.22222 8.58347 2.33333L14.7501 13C14.8168 13.1111 14.8475 13.2251 14.8421 13.342C14.8368 13.4589 14.8061 13.5671 14.7501 13.6667C14.6941 13.7662 14.6164 13.8469 14.5168 13.9087C14.4172 13.9704 14.3061 14.0009 14.1835 14H1.8168ZM2.9668 12.6667H13.0335L8.00013 4L2.9668 12.6667ZM8.47547 11.8087C8.60302 11.6807 8.6668 11.5222 8.6668 11.3333C8.6668 11.1444 8.6028 10.9862 8.4748 10.8587C8.3468 10.7311 8.18858 10.6671 8.00013 10.6667C7.81169 10.6662 7.65347 10.7302 7.52547 10.8587C7.39747 10.9871 7.33347 11.1453 7.33347 11.3333C7.33347 11.5213 7.39747 11.6798 7.52547 11.8087C7.65347 11.9376 7.81169 12.0013 8.00013 12C8.18858 11.9987 8.34702 11.9353 8.47547 11.8087ZM8.47547 9.808C8.60302 9.68044 8.6668 9.52222 8.6668 9.33333V7.33333C8.6668 7.14444 8.6028 6.98622 8.4748 6.85867C8.3468 6.73111 8.18858 6.66711 8.00013 6.66667C7.81169 6.66622 7.65347 6.73022 7.52547 6.85867C7.39747 6.98711 7.33347 7.14533 7.33347 7.33333V9.33333C7.33347 9.52222 7.39747 9.68067 7.52547 9.80867C7.65347 9.93667 7.81169 10.0004 8.00013 10C8.18858 9.99956 8.34702 9.93556 8.47547 9.808Z"
                fill="#B8944F"
              />
            </svg>
            Warnings & Precautions
          </Heading>

          <Flex style={{ marginLeft: 12, paddingLeft: 20, borderLeft: '2px solid #B8944F' }}>
            <Text dangerouslySetInnerHTML={{ __html: warnings }} />
          </Flex>
        </Flex>
      )}
    </>
  );
};

const ConsultationDetailInner = ({ id, list, history }) => {
  if (list.length < 1) {
    return (
      <WrapperFlex>
        <DetailNavigation mb={4} mt={3}>
          <BackButton onClick={() => history.push(REDIRECT_URL)}>{`<  Your Rx`}</BackButton>
        </DetailNavigation>
        <Text>An error occured</Text>
      </WrapperFlex>
    );
  }

  const element = list.find((x) => x.id === id);

  if (!element) {
    return (
      <WrapperFlex>
        <DetailNavigation mb={4} mt={3}>
          <BackButton onClick={() => history.push(REDIRECT_URL)}>{`<  Your Rx`}</BackButton>
        </DetailNavigation>
        <Text>An error occured</Text>
      </WrapperFlex>
    );
  }

  return (
    <Mutation
      mutation={GET_RX_TOKEN}
      onCompleted={(e) => {
        if (e && e.getRxToken) {
          if (isPreviewMode) {
            window.location = `https://paloma-rx-52964592056.us-central1.run.app/refill/manage/${element.id}?t=${encodeURIComponent(e.getRxToken)}`;
          } else {
            window.location = `https://rx.palomahealth.com/refill/manage/${element.id}?t=${encodeURIComponent(e.getRxToken)}`;
          }
        }
      }}
    >
      {(generateToken, { loading }) => (
        <Fragment>
          <WrapperFlex paddingLeft={'12px'}>
            <Flex flexDirection={'row'} alignItems={['flex-start', 'center', 'center']} style={{ gap: 20 }} mb={2}>
              <Flex flex={1} flexDirection={['column', 'row', 'row']} alignItems={'center'} style={{ gap: 20 }}>
                {element &&
                  element.medication &&
                  element.medication.productMetadata && (
                    <FlexMobile>
                      <ImgTopMobile src={(element.medication.productMetadata || {}).imageUrl || PillsBottle} width={'100%'} style={{ objectFit: 'scale-down' }} />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        onClick={() => history.push(REDIRECT_URL)}
                        style={{ cursor: 'pointer', position: 'absolute', top: 0, right: 0, zIndex:1 }}
                      >
                        <path
                          d="M12 13.4L7.10005 18.3C6.91672 18.4834 6.68338 18.575 6.40005 18.575C6.11672 18.575 5.88338 18.4834 5.70005 18.3C5.51672 18.1167 5.42505 17.8834 5.42505 17.6C5.42505 17.3167 5.51672 17.0834 5.70005 16.9L10.6 12L5.70005 7.10005C5.51672 6.91672 5.42505 6.68338 5.42505 6.40005C5.42505 6.11672 5.51672 5.88338 5.70005 5.70005C5.88338 5.51672 6.11672 5.42505 6.40005 5.42505C6.68338 5.42505 6.91672 5.51672 7.10005 5.70005L12 10.6L16.9 5.70005C17.0834 5.51672 17.3167 5.42505 17.6 5.42505C17.8834 5.42505 18.1167 5.51672 18.3 5.70005C18.4834 5.88338 18.575 6.11672 18.575 6.40005C18.575 6.68338 18.4834 6.91672 18.3 7.10005L13.4 12L18.3 16.9C18.4834 17.0834 18.575 17.3167 18.575 17.6C18.575 17.8834 18.4834 18.1167 18.3 18.3C18.1167 18.4834 17.8834 18.575 17.6 18.575C17.3167 18.575 17.0834 18.4834 16.9 18.3L12 13.4Z"
                          fill="#4E658A"
                        />
                      </svg>
                    </FlexMobile>
                  )}
                <Heading flex={1}>{element.medication.name}</Heading>
                <Button
                  variant={'primary'}
                  p={'6px 24px !important'}
                  style={{ backgroundColor: '#4E658A', width: 'fit-content', fontWeight: 500, flex: 'initial' }}
                  onClick={generateToken}
                  disabled={!!loading}
                >
                  Manage Rx
                </Button>
              </Flex>
              <FlexNotMobile>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={() => history.push(REDIRECT_URL)} style={{ cursor: 'pointer' }}>
                  <path
                    d="M12 13.4L7.10005 18.3C6.91672 18.4834 6.68338 18.575 6.40005 18.575C6.11672 18.575 5.88338 18.4834 5.70005 18.3C5.51672 18.1167 5.42505 17.8834 5.42505 17.6C5.42505 17.3167 5.51672 17.0834 5.70005 16.9L10.6 12L5.70005 7.10005C5.51672 6.91672 5.42505 6.68338 5.42505 6.40005C5.42505 6.11672 5.51672 5.88338 5.70005 5.70005C5.88338 5.51672 6.11672 5.42505 6.40005 5.42505C6.68338 5.42505 6.91672 5.51672 7.10005 5.70005L12 10.6L16.9 5.70005C17.0834 5.51672 17.3167 5.42505 17.6 5.42505C17.8834 5.42505 18.1167 5.51672 18.3 5.70005C18.4834 5.88338 18.575 6.11672 18.575 6.40005C18.575 6.68338 18.4834 6.91672 18.3 7.10005L13.4 12L18.3 16.9C18.4834 17.0834 18.575 17.3167 18.575 17.6C18.575 17.8834 18.4834 18.1167 18.3 18.3C18.1167 18.4834 17.8834 18.575 17.6 18.575C17.3167 18.575 17.0834 18.4834 16.9 18.3L12 13.4Z"
                    fill="#4E658A"
                  />
                </svg>
              </FlexNotMobile>
            </Flex>
            <StatusBadge prescription={element} />
            <Flex flexDirection={'column'} mt={4} style={{ gap: 28 }}>
              <PrescriptionDetails prescription={element} manageRx={generateToken} isLoadingManage={!!loading} />
              {!!element.athenaAppointmentId && <LatestFromPhysician appointmentId={element.athenaAppointmentId} />}
              <FillsHistory prescription={element} />
              <ProductInformation prescription={element} />
              <CheckoutSummary prescription={element} />
              <ProductSpecifications productMetadata={((element || {}).medication || {}).productMetadata} />

              <Button
                variant={'primary'}
                p={'6px 24px !important'}
                alignSelf={'center'}
                justifySelf={'center'}
                mt={4}
                mb={4}
                style={{ backgroundColor: '#4E658A', width: 'fit-content', fontWeight: 500, flex: 'initial' }}
                onClick={generateToken}
                disabled={!!loading}
              >
                Manage Rx
              </Button>

              {element.medication &&
                element.medication.productMetadata &&
                element.medication.productMetadata.medicationGuideUrl && (
                  <Text p={'6px 24px !important'} alignSelf={'center'} justifySelf={'center'} style={{}} onClick={() => window.open(element.medication.productMetadata.medicationGuideUrl, '_blank')}>
                    <Text style={{ fontWeight: 300, fontSize: '14px' }}>
                      For complete prescribing and safety information, <span style={{ fontWeight: 500, textDecoration: 'underline', cursor: 'pointer' }}>view the Medication Guide</span>
                    </Text>
                  </Text>
                )}

              {/* <RxCommunicator prescription={element} /> */}
            </Flex>
          </WrapperFlex>
        </Fragment>
      )}
    </Mutation>
  );
};

const PalomaRxDetails = ({ id, list, history, match }) => {
  useEffect(() => {
    const element = document.getElementById('toMaxUp');
    if (!element) return;

    // Save the original value
    const originalOverflow = element.style.overflow;

    // Set overflow hidden
    element.style.overflow = 'hidden';

    // Restore on unmount
    return () => {
      element.style.overflow = originalOverflow;
    };
  });
  if (!match || !match.params || !match.params.id) {
    history.replace(REDIRECT_URL);
    return null;
  }
  if (list && !!list.find((x) => x.id === match.params.id)) {
    return <ConsultationDetailInner id={match.params.id} list={list} history={history} />;
  }
  return (
    <Query query={GET_PALOMA_RX} fetchPolicy={'network-only'}>
      {({ loading, error, data }) => {
        if (loading) {
          return (
            <WrapperFlex>
              <DetailNavigation mb={4} mt={3}>
                <BackButton onClick={() => history.push(REDIRECT_URL)}>{`<  Your Rx`}</BackButton>
              </DetailNavigation>
              <Flex flex={1} justifyContent="center" alignItems="center">
                <SpinLoader />
              </Flex>
            </WrapperFlex>
          );
        }

        if (error) {
          return (
            <WrapperFlex>
              <DetailNavigation mb={4} mt={3}>
                <BackButton onClick={() => history.push(REDIRECT_URL)}>{`<  Your Rx`}</BackButton>
              </DetailNavigation>
              <Flex flex={1} justifyContent="center" alignItems="center">
                <Text>An error occured</Text>
              </Flex>
            </WrapperFlex>
          );
        }

        if (!data || !data.getPalomaRxs) {
          history.replace(REDIRECT_URL);
          return null;
        }
        return <ConsultationDetailInner list={data.getPalomaRxs || []} id={match.params.id} history={history} />;
      }}
    </Query>
  );
};

export default compose(
  withRouter,
  withApollo,
  withToastManager,
  withAnalytics,
)(PalomaRxDetails);
